export const availableTags = [
    'all',
    'update',
    'announcement',
    'gift',
    'holiday',
    'contest',
    'puzzle',
    'tip',
    'discussion',
] as const

export type Tag = (typeof availableTags)[number]

// NOTE: в старых постах теги произвольно выставлялись
export const isTag = (label: string): label is Tag => availableTags.includes(label as Tag)

export function isAll(tag: Tag): boolean {
    return tag === 'all'
}
